module.exports = __webpack_public_path__ + "img/4_1.b3bd3b61.png";